<template>
  <div class="col-12">
    <div class="row border-bottom">
      <div class="col-12 col-sm-7 pb-1 font-size-sm font-weight-bold mb-1"> {{ label }} </div>
      <div class="col-12 col-sm-5 ml-auto">
        <div id="dropdownMenuExtraSmall" class="disclosure-info pb-2 dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Istruzioni di ricerca</div>
<div class="dropdown-menu dropdown-menu-xs alert-pastel" aria-labelledby="dropdownMenuExtraSmall">
	<div class="font-size-xxs">
		<p>Cliccando su CERCA CASINÒ ti verranno mostrati tutti i casinò certificati da Casino2K che hanno licenza ADM.
Puoi restringere i risultati di ricerca selezionando uno o più criteri tra quelli mostrati. Ad esempio con pochi click potrai trovare un concessionario che offre giochi di casinò e poker, in cui sia disponibile il blackjack live e dove sia possibile prelevare con PayPal.</p>
<p>Dai risultati è anche possibile aggiungere i casinò al confronto cliccando sul bottone AGGIUNGI AL CONFRONTO e quindi sul bottone CONFRONTA per paragonarne le caratteristiche.</p>
	</div>
</div>
      </div>
    </div>
<div class="d-flex flex-sm-row flex-wrap justify-content-left align-items-left mb-3 border-bottom">
    <div class="m-1" v-for="option of options" v-bind:key="option.value">
      <label class="font-size-xs m-0 badge badge-success-soft">
        <input
                :checked="$store.getters.filters.casino && $store.getters.filters.casino.find(e => e.type == 'products') && $store.getters.filters.casino.find(e => e.type == 'products').value.includes(option.value)"
          type="checkbox"
          v-bind:name="name"
          v-bind:value="option.value"
          @click="addFilter($event)"
        />
        {{ option.name }}
      </label>
    </div>
    </div>
  </div>
</template>

<script>
import store from '../store';
import { isEntityVisible } from '../filter.function';
export default {
  name: 'CheckboxFilter',
  store,
  props: ['options', 'label', 'name'],
  components: {},
  data: function() {
    return {
      appliedFilters: store.getters.filters.casino && store.getters.filters.casino.find(e => e.type === 'products') ?  store.getters.filters.casino.find(e => e.type === 'products').value : [] ,
    };
  },
  methods: {
    addFilter(event) {
      event.target.checked
        ? this.appliedFilters.push(parseInt(event.target.value))
        : (this.appliedFilters = this.appliedFilters.filter(
            (e) => e !== parseInt(event.target.value)
          ));

      if (this.appliedFilters.length) {
        if (store.getters.filters.casino.find((e) => e.type == 'products')) {
          store.getters.filters.casino.find(
            (e) => e.type == 'products'
          ).value = this.appliedFilters;
          store.commit('setFilters', store.getters.filters);
        } else {
          store.getters.filters.casino.push({
            type: 'products',
            value: this.appliedFilters,
          });
            store.commit('setFilters', store.getters.filters);

        }
      } else {
        store.commit('setFilters', {
          ...store.getters.filters,
          casino: store.getters.filters.casino.filter(
            (e) => e.type !== 'products'
          ),
        });
      }

      this.filterResults();
    },

    filterResults() {
        const finalResults = [];
      for (let result of store.getters.results) {
        result.visible = isEntityVisible(store.getters.filters.casino, result);
        finalResults.push(result)
      }
        store.commit('setResults', finalResults);

    },
  },
};
</script>
